import { IoFolder } from "react-icons/io5";
import { BiDuplicate } from "react-icons/bi";
import { CiMenuKebab } from "react-icons/ci";
import { LuFolderPlus } from "react-icons/lu";
import { MdContentCopy } from "react-icons/md";
import { useEffect, useRef, useState } from "react";
import { Collapse, ListGroup, Spinner } from "react-bootstrap";
import { BsFillFileEarmarkZipFill } from "react-icons/bs";
import { FaFolder, FaTrashAlt, FaEdit } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp, IoIosDesktop, IoIosMove } from "react-icons/io";
import { s3FileManagerServices } from "../../../APIServices/SitePilotManagement/s3FileManagerServices";
import Swal from "sweetalert2";
import UseToggle from "../../../Hooks/UseToggle";
import MoveFolder from "./MoveFolder";
import CopyFolder from "./CopyFolder";
import AddNewFolder from "./AddNewFolder";
import UpdateFolder from "./UpdateFolder";
import DuplicateFolder from "./DuplicateFolder";
import GenerateZipFile from "./GenerateZipFile";
import { FiTrash } from "react-icons/fi";

function FileManagementSidebar({
  setObjectData,
  objectData,
  setTrashData,
  trashData
}) {
  const toggles = UseToggle();
  const AppsRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [folderData, setFolderData] = useState("");
  const [activeMenu, setActiveMenu] = useState("");
  const [fileManager, setFileManager] = useState([]);

  const [openFolders, setOpenFolders] = useState({});

  const toggleFolder = (folderId) => {
    setOpenFolders(prev => ({ ...prev, [folderId]: !prev[folderId] }));
  };

  const getS3Folders = async () => {
    setLoader(true);
    let data = await s3FileManagerServices.getS3Folders("root", "", "", "folder");
    setFileManager(data?.data || []);
    setLoader(false);
  };

  const softDeleteS3Folder = async (path) => {
    Swal.fire({
      icon: "warning",
      title: "Are you sure?",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonColor: "#103C5E",
      confirmButtonText: `Yes, Delete it!`,
      text: `You want to Delete this folder!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.path = [path];
        userData.type = "delete";
        let data = await s3FileManagerServices.softDeleteS3Folder(userData);
        if (data?.statusCode === 200) {
          if (objectData?.fullPath === path) {
            // handleDeleteTab("fileManagement")
          }
        }
      }
    });
  };

  useEffect(() => {
    getS3Folders();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (AppsRef.current && !AppsRef.current.contains(event.target) && !event.target.closest(".node-menu") && !event.target.closest(".kebab-icon")) {
        setActiveMenu("");
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => document.removeEventListener("click", handleClickOutside, true);
  }, []);

  return (
    <>
      <ListGroup.Item className="border-0 border-bottom bg-light" style={{ padding: "4.7px 10px" }} ref={AppsRef}>
        <div className="hstack justify-content-between w-100">
          <span
            className="fw-bold CP">
            <IoIosDesktop className="me-1" />
            <span style={{ fontSize: 14 }}>File Management</span>
          </span>
          <span className="fw-bold">
            <LuFolderPlus onClick={() => { toggles.setToggle(); setFolderData("") }} className="me-2 CP" style={{ fontSize: 16 }} />
          </span>
        </div>
      </ListGroup.Item>
      <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 125px)" }}>
        {loader ? (
          <div className="hstack h-100 justify-content-center">
            <Spinner />
          </div>
        ) : fileManager?.length === 0 ? (
          <div className="hstack h-100 justify-content-center" style={{ fontSize: 12 }}>
            Folder not found!
          </div>
        ) : (
          fileManager?.map((node) =>
            <TreeNode
              node={node}
              toggles={toggles}
              key={node.fullPath}
              objectData={objectData}
              folderData={folderData}
              activeMenu={activeMenu}
              openFolders={openFolders}
              toggleFolder={toggleFolder}
              setFolderData={setFolderData}
              setActiveMenu={setActiveMenu}
              softDeleteS3Folder={softDeleteS3Folder}
              setObjectData={setObjectData}
              setTrashData={setTrashData}
            />)
        )}
      </ListGroup>
      <ListGroup.Item
        onClick={() => {setTrashData(true); setObjectData("")}}
        className={`border-0 border-top CP ${trashData && "bg-danger"}`} title="Recycle Bin" style={{ padding: "5px 10px" }} ref={AppsRef}>
        <span className={`${trashData ? "text-white" : "text-danger"} fw-bold`}>
          <FiTrash className={`me-2`}></FiTrash>
          <span style={{ fontSize: 12 }}>Recycle Bin</span>
        </span>
      </ListGroup.Item>
      <AddNewFolder
        Title="Add New Folder"
        Show={!toggles.toggle}
        folderData={folderData}
        Hide={toggles.setToggle}
        getTotalS3Folders={getS3Folders}
      />
      <UpdateFolder
        folderData={folderData}
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        sourceKey={[folderData?.fullPath]}
        Title={`Update ${folderData?.name} Folder`}
        getTotalS3Folders={getS3Folders}
      />
      <CopyFolder
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        sourceKey={[folderData?.fullPath]}
        Title={`Copy ${folderData?.name} in Other Folder`}
        getTotalS3Folders={getS3Folders}
      />
      <MoveFolder
        Show={!toggles.toggle3}
        folderData={folderData}
        Hide={toggles.setToggle3}
        sourceKey={[folderData?.fullPath]}
        Title={`Move ${folderData?.name} Folder`}
        getTotalS3Folders={getS3Folders}
      />
      <DuplicateFolder
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        sourceKey={[folderData?.fullPath]}
        Title={`Duplicate ${folderData?.name} Folder`}
        getTotalS3Folders={getS3Folders}
      />
      <GenerateZipFile
        Show={!toggles.toggle5}
        Hide={toggles.setToggle5}
        Title={`Generate ${folderData?.name} Zip`}
        sourceKey={[folderData?.fullPath]}
        getTotalS3Folders={getS3Folders}
      />
    </>
  );
}

function TreeNode({
  node,
  toggles,
  depth = 0,
  objectData,
  folderData,
  activeMenu,
  openFolders,
  toggleFolder,
  setFolderData,
  setActiveMenu,
  softDeleteS3Folder,
  setObjectData,
  setTrashData
}) {
  const isFolder = !node.isFile && node.children?.length > 0;
  const isOpen = openFolders[node.fullPath] || false;

  return (
    <>
      <ListGroup.Item
        action
        title={node?.sizeMB}
        className={`border-0 border-bottom hstack justify-content-between rounded-0 w-100 ${objectData?.fullPath === node?.fullPath ? "selectedMenu" : isOpen ? "bg-light" : ""}`}
        style={{ paddingLeft: depth + 16, paddingTop: 7, paddingBottom: 7, fontSize: 13 }}
      >
        <div
          className="d-flex align-items-center flex-grow-1"
          onClick={() => {
            if (!node.isFile) {
              toggleFolder(node.fullPath);
              setObjectData(node)
              setTrashData(false)
            }
          }}
        >
          {node?.name === "Uncategories" ? <IoFolder className="me-1 text-info" /> : <FaFolder className="me-1 text-warning" />}
          <span>{node.name}</span>
        </div>
        <div className="hstack gap-2">
          {isFolder && (isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />)}
          <div
            className="kebab-icon"
            onClick={(e) => {
              e.stopPropagation();
              setActiveMenu(activeMenu === node.fullPath ? "" : node.fullPath);
            }}
          >
            <CiMenuKebab />
          </div>
        </div>
        <Collapse in={activeMenu === node.fullPath}>
          <div
            className="position-absolute z-1 node-menu"
            style={{ top: 34, right: 0 }}
            onClick={(e) => e.stopPropagation()}
          >
            <NodeActions
              node={node}
              toggles={toggles}
              folderData={folderData}
              setFolderData={setFolderData}
              softDeleteS3Folder={softDeleteS3Folder}
            />
          </div>
        </Collapse>
      </ListGroup.Item>
      {isFolder && (
        <Collapse in={isOpen}>
          <ListGroup>
            {node.children?.map((child) => (
              <TreeNode
                node={child}
                key={child.name}
                toggles={toggles}
                depth={depth + 16}
                objectData={objectData}
                folderData={folderData}
                activeMenu={activeMenu}
                openFolders={openFolders}
                toggleFolder={toggleFolder}
                setFolderData={setFolderData}
                setActiveMenu={setActiveMenu}
                softDeleteS3Folder={softDeleteS3Folder}
                setObjectData={setObjectData}
                setTrashData={setTrashData}
              />
            ))}
          </ListGroup>
        </Collapse>
      )}
    </>
  );
}

function NodeActions({
  node,
  toggles,
  setFolderData,
  softDeleteS3Folder
}) {
  return (
    <ListGroup className="br3 small">
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle(); }}
      >
        <FaFolder className="me-1" /> Add New Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle1(); }}
      >
        <FaEdit style={{ marginLeft: -1 }} className="me-1" /> Rename Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle2(); }}
      >
        <MdContentCopy style={{ marginLeft: -1 }} className="me-1" /> Copy Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle3() }}
      >
        <IoIosMove style={{ marginLeft: -1 }} className="me-1" /> Move Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
        onClick={(e) => { setFolderData(node); toggles.setToggle4(); }}
      >
        <BiDuplicate style={{ marginLeft: -1 }} className="me-1" /> Duplicate Folder
      </ListGroup.Item>
      <ListGroup.Item
        action
        onClick={(e) => {
          setFolderData(node);
          toggles.setToggle5();
        }}
        className="text-primary py-1 px-3 fontSize12 text-nowrap"
      >
        <BsFillFileEarmarkZipFill style={{ marginLeft: -1 }} className="me-1" /> Generate Zip
      </ListGroup.Item>
      <ListGroup.Item
        action
        className="text-danger py-1 px-3 fontSize12 text-nowrap"
        onClick={() => softDeleteS3Folder(node?.fullPath)}
      >
        <FaTrashAlt style={{ marginLeft: -1 }} className="me-1" /> Delete Folder
      </ListGroup.Item>
    </ListGroup>
  );
}

export default FileManagementSidebar;
